import { MEDIA } from "./site";

// Display strings (name, tagline, description, accent) live in src/locales/*.json
// keyed by `key` / `id`. Only structural and numeric data stays here.
export const CATEGORIES = [
    { key: "rough-blocks", i18nKey: "rough_blocks", hsn: "2516.11", image: MEDIA.heroSecondary },
    { key: "cut-slabs", i18nKey: "cut_slabs", hsn: "2516.12", image: MEDIA.slab1 },
];

// `finishes` and any non-numeric size/thickness entries are i18n keys resolved
// through `product_meta.*`; plain dimensional strings are shown as-is.
export const PRODUCTS = [
    {
        id: "p-polished-black-granite",
        formKey: "polished_black",
        category: "cut-slabs",
        origin: "South India",
        finishes: ["polished"],
        sizes: ["standard_slabs", "custom_on_request"],
        thickness: ["18 mm", "20 mm", "30 mm"],
        image: MEDIA.polishedBlack,
    },
    {
        id: "p-black-galaxy",
        formKey: "black_galaxy",
        category: "cut-slabs",
        origin: "Ongole / Krishnagiri",
        finishes: ["polished", "honed", "flamed", "leathered"],
        sizes: ["260×160 cm", "≤ 3.0 m³"],
        thickness: ["18 mm", "20 mm", "30 mm", "block"],
        image: MEDIA.slab1,
    },
    {
        id: "p-tan-brown",
        formKey: "tan_brown",
        category: "cut-slabs",
        origin: "South India",
        finishes: ["polished", "honed", "flamed"],
        sizes: ["280×170 cm", "2.4-3.2 m³"],
        thickness: ["18 mm", "20 mm", "30 mm"],
        image: MEDIA.slab2,
    },
    {
        id: "p-steel-grey",
        formKey: "steel_grey",
        category: "cut-slabs",
        origin: "Krishnagiri / Karnataka",
        finishes: ["polished", "honed", "leathered"],
        sizes: ["260×160 cm"],
        thickness: ["18 mm", "20 mm", "30 mm"],
        image: MEDIA.mfg1,
    },
    {
        id: "p-imperial-red",
        formKey: "imperial_red",
        category: "cut-slabs",
        origin: "South India",
        finishes: ["polished", "honed", "flamed"],
        sizes: ["240×140 cm", "2.0-2.8 m³"],
        thickness: ["18 mm", "20 mm", "30 mm"],
        image: MEDIA.arch1,
    },
    {
        id: "p-block-black-galaxy",
        formKey: "rough_blocks",
        category: "rough-blocks",
        origin: "Krishnagiri",
        finishes: ["as_mined", "six_side_dressed"],
        sizes: ["2.4-3.2 m³"],
        thickness: ["full_block"],
        image: MEDIA.heroSecondary,
    },
    {
        id: "p-block-tan-brown",
        formKey: "rough_blocks",
        category: "rough-blocks",
        origin: "Krishnagiri",
        finishes: ["as_mined", "six_side_dressed"],
        sizes: ["1.8-2.8 m³"],
        thickness: ["full_block"],
        image: MEDIA.mfg1,
    },
    {
        id: "p-block-steel-grey",
        formKey: "rough_blocks",
        category: "rough-blocks",
        origin: "Krishnagiri / Karnataka",
        finishes: ["as_mined", "six_side_dressed"],
        sizes: ["2.0-3.0 m³"],
        thickness: ["full_block"],
        image: MEDIA.mfg2,
    },
    {
        id: "p-block-imperial-red",
        formKey: "rough_blocks",
        category: "rough-blocks",
        origin: "South India",
        finishes: ["as_mined", "six_side_dressed"],
        sizes: ["1.8-2.6 m³"],
        thickness: ["full_block"],
        image: MEDIA.arch2,
    },
];
